module.exports = __webpack_public_path__ + "media/images/athletes/4318-38e2240777332fa58844cc86edf4c1c1.png";